import React from 'react';
import {Table} from "semantic-ui-react";
import styled, {css} from "styled-components";

export const StyledTable = styled(Table)`
  border: 0 !important;

  tr td {
    border-top: 1px solid rgba(196, 214, 233, 1) !important;
    border-bottom: 0 !important;
    vertical-align: middle !important;
    height: auto;
    min-height: 90px;
    line-height: 16px !important;
    word-wrap: break-word;
    word-break: break-word;
    white-space: normal;
    overflow-wrap: break-word;
  }

  tr:last-child td:not(.loader) {
    border-bottom: 1px solid rgba(196, 214, 233, 1) !important;
  }
  tr:last-child td.loader, tr:last-child td.loader:hover {
    background-color: #fff !important;
    border-top: none !important;
    height: 40vh;
    margin-top: auto;
    margin-bottom: 0;
  }
  
  tr:not(.disabled-tr):hover td {
    background: #E9F0F5 !important;
  }

  .row_green td {
    background: rgba(6,135,42,.1) !important;
  }
  
  ${({$striped}) => $striped && css`
    tr:nth-child(2n-1) td {
      background: rgba(250, 251, 253, 1);
    }
  `}
  
  thead th {
    font-style: normal;
    font-weight: 400 !important;
    font-size: 14px;
    line-height: 19px !important;

    align-items: center;

    color: #475566 !important;
    border: 0 !important;
    background-color: white !important;
  }

  .table {
    &__date {
      color: black;
    }

    &__week-day {
      color: rgba(71, 85, 102, 1);
    }

    &__cost-calc {
      color: #135CA9;
      font-weight: 700 !important;
    }

    &__days-count {
      font-weight: 700 !important;
      padding-right: 1em !important;
      padding-left: 1em !important;
      white-space: nowrap;
      
      &_0 {
        width: 80px;
        font-size: 12px;
        color: #E20D18;
        position: relative;
        background: #FFFFFF;
        border: 1px solid #C4D6E9;
        border-radius: 26px;
        padding: 4px 10px 4px 25px !important;
        background-image: url('data:image/svg+xml;base64,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') !important;
        background-repeat: no-repeat;
        background-position: center left 10px;
        margin: auto;
      }
    }
    
    &__info {
      padding-right: 50px !important;
      padding-left: 50px !important;
    }

    &__btn {
      box-shadow: none !important;
      background: #FFFFFF;
      border: 1px solid #459EFF;
      border-radius: 38px;
      color: #135CA9;
      white-space: nowrap;
      
      &_big {
        padding: 14px 38px;
      }

      &:hover {
        background: #135CA9;
        border: 1px solid #135CA9;
        color: white;
      }
    }
  }
`;

const TableStyled = ({children, striped = true}) => {
    return (
        <StyledTable $striped={striped}>
            {children}
        </StyledTable>
    );
};

export default TableStyled;


// WEBPACK FOOTER //
// ./App/components/Table/Table.jsx